import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { useApiClient } from "../../contexts/ApiClientContext";
import PathInfo from "../../model/PathInfo";
import APIEndPoints from "../../utils/APIEndPoints";
import PathDisplay from "../common/PathDisplay";
import e3dModel from "../../model/e3dModel";
import ChemiNovaEntityType from "../../model/enums/ChemiNovaEntityType";

/*
  Component to manage the entire E3D Models section
*/
function E3Ds() {
  // read the ID from the url
  const { e3did, id } = useParams();
  const auxId = id ? id : e3did;
  // store data path
  const [pathInfo, setPathInfo] = useState<PathInfo | undefined>(undefined);
  // reference to the ApiClient instance
  const apiClient = useApiClient();
  // reference to Location, to update path when it changes
  const location = useLocation();

  useEffect(() => {
    const getPathInfo = async () => {
      if (auxId) {
        const info = await apiClient?.get<e3dModel>({
          url: APIEndPoints.E3DS.ONE(parseInt(auxId)),
        });

        setPathInfo(
          new PathInfo(
            info.id!,
            info.name,
            ChemiNovaEntityType.E3DMODEL,
            info.parent,
            e3did ? false : true
          )
        );
      }
    };
    getPathInfo();
  }, [location]);

  return (
    <div>
      <PathDisplay data={pathInfo!} />
      <Outlet />
    </div>
  );
}

export default E3Ds;
